import { oneTrust, akamiZipCode, cartCount, deliveryLocation, wc_member, storeLocation, warehouse, wcCartOrder } from "./legacyCookieStorage.js";
import { userPreferences } from "./localStorage.js";
const getInitialCartState = () => {
  return {
    cartItemCount: cartCount.read(),
    orderItems: []
  };
};
const getInitialDeliveryLocationState = () => {
  return deliveryLocation.read() || { city: "", state: "", zipCode: "" };
};
const getInitialWcMemberState = () => {
  return wc_member.read() || "";
};
const getInitialUserLocationState = () => {
  return storeLocation.read() || {
    city: "",
    zip: ""
  };
};
const getInitialWarehouseState = () => {
  return warehouse.read() || {
    distributionCenters: [],
    groceryCenters: [],
    nearestWarehouse: {},
    pickUpCenters: []
  };
};
const getInitialUserPreferencesState = async () => {
  return await userPreferences.read() || {
    currency: "USD",
    locale: navigator.language
  };
};
const thirdPartyInfoInitialState = {
  akamaiZipCode: akamiZipCode.read(),
  criterioSessionId: "",
  consentManagement: oneTrust.read()
};
const cartInitialState = {
  cartItemCount: 0,
  orderItems: []
};
const getInitialOrderPrice = () => {
  return wcCartOrder.read() || 0;
};
export {
  cartInitialState,
  getInitialCartState,
  getInitialDeliveryLocationState,
  getInitialOrderPrice,
  getInitialUserLocationState,
  getInitialUserPreferencesState,
  getInitialWarehouseState,
  getInitialWcMemberState,
  thirdPartyInfoInitialState
};
